import EventDispatcher from "@/events/EventDispatcher";
import Event from "@/events/Event";

export class WindowVisibilityChecker extends EventDispatcher {
  public hidden: string = 'hidden';
  public visibilityChange = 'visibilityChange';
  
  constructor () {
    super();
    
    if (typeof document.hidden !== "undefined") {
      this.hidden = "hidden";
      this.visibilityChange = "visibilitychange";
    } else {
      this.hidden = "webkitHidden";
      this.visibilityChange = "webkitvisibilitychange";
    }
  }
  
  public enableCheck (): void {
    // @ts-ignore
    document.addEventListener(this.visibilityChange, this.onVisibilityChange, false);
  }
  
  public disEnableCheck (): void {
    // @ts-ignore
    document.removeEventListener(this.visibilityChange, this.onVisibilityChange);
  }
  
  private onVisibilityChange = (ev: Event): void => {
    if (document[this.hidden]) {
      this.dispatchEvent(new WindowVisibilityEvent(WindowVisibilityEvent.HIDDEN));
    }
    else {
      this.dispatchEvent(new WindowVisibilityEvent(WindowVisibilityEvent.VISIBLE));
    }
  }
}

export class WindowVisibilityEvent extends Event {
  static VISIBLE: string = 'visible';
  static HIDDEN: string = 'hidden';
  
  constructor(type:string, bubbles:boolean = null, cancelable:boolean = null) {
    super(type, bubbles, cancelable);
  }
}
